export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 150 },
  // { key: '2', headerName: 'SubZone Code', field: 'id', hide: false, width: 150 },
  { key: '3', headerName: 'Sub Zone Name', field: 'name', hide: false, width: 300 },
  { key: '4', headerName: 'Zone', field: 'zonel_name', hide: false, width: 250 },
  { key: '5', headerName: 'State', field: 'state_name', hide: false, width: 250 },
  { key: '6', headerName: 'Status', field: 'status', hide: false, width: 200 },
];
